import request from '@/utils/request';

// 上线售卖
export function saveGoods(params) {
  return request({
    url: '/dynamic/info/goods',
    method: 'put',
    data: params,
  });
}
// 查询产品日历
export function queryGoodsCalendar(params) {
  return request({
    // url: '/room/goods/calendar'
    url: '/dynamic/info/goods/calendar',
    method: 'get',
    params,
  });
}
// 查询产品日历(new)
export function queryGoodsCalendarNew(params) {
  return request({
    url: '/dynamic/info/deepoperate/calendar',
    method: 'get',
    params,
  });
}
// 动态更新产品动态信息
export function dynamicGetEBGoodsstatus(params) {
  return request({
    url: '/dynamic/info/deepoperate/dynamicGetEBGoodsstatus',
    method: 'post',
    params,
    notCheckRepeat: true,
  });
}

// 深度运营同步EB产品房价房态修改Mq
export function fetchDeepOperateHotelRoomGoods(params) {
  return request({
    url: '/dynamic/info/deepoperate/fetchDeepOperateHotelRoomGoods',
    method: 'post',
    params,
  });
}
// 查询产品页面的码值表：房型和产品类型
export function getCfg(params) {
  return request({
    url: '/dynamic/info/goods/cfg',
    method: 'get',
    params,
  });
}

// 查询产品的可用渠道列表
export function getGoodsChannel(params) {
  return request({
    url: '/dynamic/info/goods/channel',
    method: 'get',
    params,
  });
}
// 产品下线
export function postGoodsDown(params) {
  return request({
    url: '/room/goods/down',
    method: 'post',
    params,
  });
}
// 产品删除
export function deleteProduct(params) {
  return request({
    url: '/dynamic/info/delete',
    method: 'post',
    data: params,
    notCheckRepeat: true,
  });
}
// 设置产品限售
export function postGoodsLimit(params) {
  return request({
    url: '/dynamic/info/goodsPrice/setLimitNum', // '/room/goods/limit',
    method: 'post',
    data: params,
  });
}
// 设置EB产品限售
export function postGoodsLimitEB(params) {
  return request({
    url: '/dynamic/info/deepoperate/setEBLimitNum', // '/room/goods/limit',
    method: 'post',
    data: params,
    notCheckRepeat: true,
  });
}
// 设置产品价格
export function postGoodsPrice(params) {
  return request({
    url: '/dynamic/info/goodsPrice/setPrice', // '/room/goods/price',
    method: 'post',
    data: params,
  });
}

// 设置产品价格
export function queryFestivalDate(params) {
  return request({
    url: '/dynamic/info/goodsPrice/queryFestivalDate', // '/room/goods/price',
    method: 'get',
    data: params,
  });
}

// 设置EB产品价格
export function postGoodsPriceEB(params) {
  return request({
    url: '/dynamic/info/deepoperate/setEBGoodsPrice', // '/room/goods/price',
    method: 'post',
    data: params,
    notCheckRepeat: true,
  });
}

// 查询产品明细
export function getGoodsGoodId(params) {
  return request({
    url: '/dynamic/info/goods/id',
    method: 'get',
    params,
  });
}
// 查询是否是别样红酒店
export function getPmscode(params) {
  return request({
    url: '/dynamic/info/goods/pmscode',
    method: 'get',
    params,
  });
}
// 查询酒店渠道
export function getHotelChannel(params) {
  return request({
    url: '/dynamic/info/goods/hotel/channel',
    method: 'get',
    params,
  });
}
// 上线
export function getEnable(params) {
  return request({
    url: '/dynamic/info/goodsChannel/online',
    method: 'post',
    data: params,
  });
}
// 下线
export function getDisable(params) {
  return request({
    url: '/dynamic/info/goodsChannel/offline',
    method: 'post',
    data: params,
  });
}
// 上线
// export function getEnable(params) {
//   return request({
//     url: '/room/goods/enable',
//     method: 'put',
//     data: params,
//     notCheckRepeat: true
//   })
// }
// // 下线
// export function getDisable(params) {
//   return request({
//     url: '/room/goods/disable',
//     method: 'put',
//     data: params,
//     notCheckRepeat: true
//   })
// }

// 酒店超售配置
export function getHotelOversaleConfig(params) {
  return request({
    url: '/dynamic/info/roomOverbookingInventory/overBookingConfigList',
    method: 'get',
    params,
  });
}
// 房型超售配置
export function getRoomTypeOversaleConfig(params) {
  return request({
    url: '/dynamic/info/roomOverbookingInventory/overBookingConfigDetail',
    method: 'get',
    params,
  });
}
// 修改房型超售配置
export function updateRoomTypeOversaleConfig(params) {
  return request({
    url: '/dynamic/info/roomOverbookingInventory/updateRoomOverbookingInventory',
    method: 'post',
    data: params,
  });
}
export function getProductOperateLog(params) {
  return request({
    url: '/dynamic/info/goodsInfoOperationLog/listGoodsInfoOperationLog',
    method: 'get',
    params,
  });
}
// 获取房型产品
export function getGoodsListByHotelCode(params) {
  return request({
    url: '/dynamic/info/getGoodsListByHotelCode',
    method: 'get',
    params,
  });
}
// 获取渠道信息
export function getChannelByHotelCode() {
  return request({
    url: '/dynamic/info/queryChannelByHotelCode',
    method: 'get',
  });
}
// 价格日历 - 价格计算器
export function priceCalc(params) {
  return request({
    url: '/dynamic/info/priceCalendarCalculation',
    method: 'get',
    params,
  });
}
// 深度运营产品操作日志查询接口
export function getLogData(params) {
  return request({
    url: '/dynamic/info/deepoperate/listGoodsInfoOperationLog',
    method: 'get',
    params,
  });
}
// 深度运营查询当前酒店下的所有产品 价格日历批量改价用到
export function getDeepOperateJmcgoods(data) {
  return request({
    url: '/dynamic/info/deepoperate/getDeepOperateJmcgoods',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}

export function getDpgoodsPriceByCondition(data) {
  return request({
    url: '/dynamic/info/deepoperate/getDpgoodsPriceByCondition',
    method: 'post',
    data,
  });
}

export function batchSetDpGoodsPrice(data) {
  return request({
    url: '/dynamic/info/deepoperate/batchSetDpGoodsPrice',
    method: 'post',
    data,
  });
}

export function syncCheck(data) {
  return request({
    url: '/channel-agent/eb/mapping/check',
    method: 'get',
    data,
  });
}

// 深度运营批量设置EB产品限售和房态
export function batchSetDpGoodsInv(data) {
  return request({
    url: '/dynamic/info/deepoperate/batchSetDpGoodsInv',
    method: 'post',
    data,
  });
}

// 文章管理-文章详情
export function essayDetail(params) {
  return request({
    url: '/admin/market/essay/essayDetail',
    method: 'get',
    params,
  });
}

export function checkGoodsSalePrice(params) {
  return request({
    url: '/dynamic/info/goodsPrice/checkGoodsSalePrice',
    method: 'post',
    data: params,
  });
}

export function autosetpriceconfGet() {
  return request({
    url: '/dynamic/info/autosetpriceconf/get',
    method: 'post',
  });
}

export function autosetpriceconfSave(params) {
  return request({
    url: 'dynamic/info/autosetpriceconf/save',
    method: 'post',
    data: params,
    notCheckRepeat: true,
  });
}

// 售卡排行榜
export function rankingInfo() {
  return request({
    url: '/order/ranking/info',
    method: 'get',
  });
}

//超售库存
export function queryRoomOverbookingInventoryLog(params) {
  return request({
    url: '/dynamic/info/roomOverbookingInventory/queryRoomOverbookingInventoryLog',
    method: 'get',
    params,
  });
}

//日志
export function getLog(params) {
  return request({
    url: '/rms/app/common/log',
    method: 'post',
    data: params,
  });
}
//建议反馈
export function getFeedback(params) {
  return request({
    url: '/rms/qingyingbao/feedback',
    method: 'post',
    data: params,
  });
}

// 获取房型产品新接口
export function getAllGoodsByHotelCodeAndRoomCode(params) {
  return request({
    url: '/dynamic/info/getAllGoodsByHotelCodeAndRoomCode',
    method: 'get',
    params,
  });
}

//分页查询审核申请
export function queryModifyPriceCheckForPage(params) {
  return request({
    url: '/dynamic/info/queryModifyPriceCheckForPage',
    method: 'get',
    params,
  });
}

//分页查询申请的每日价格
export function queryModifyDailyPrice(params) {
  return request({
    url: '/dynamic/info/queryModifyDailyPrice',
    method: 'get',
    params,
  });
}

//审核通过
export function passModifyPriceCheck(params) {
  return request({
    url: '/dynamic/info/passModifyPriceCheck',
    method: 'get',
    params,
  });
}

//审核驳回
export function rejectModifyPriceCheck(params) {
  return request({
    url: '/dynamic/info/rejectModifyPriceCheck',
    method: 'get',
    params,
  });
}

//全部驳回
export function rejectAllModifyPriceCheck(params) {
  return request({
    url: 'dynamic/info/rejectAllModifyPriceCheck',
    method: 'get',
    params,
  });
}

// 根据酒店编码查询开放售卖房型及其顺序
export function getAllOpenSalesRoomTypesByHotelCode(params) {
  console.log(params);
  return request({
    url: `/admin/baseInfo/roomTypes/getAllOpenSalesRoomTypesByHotelCode/${params.hotelCode}`,
    method: 'get',
    params,
  });
}

// 批量修改房型排序数据
export function addOrUpdateRoomTypeSequence(data) {
  return request({
    url: `/admin/baseInfo/roomTypeSequence/addOrUpdateRoomTypeSequence`,
    method: 'post',
    data,
  });
}

// 检查是否支持两年价格
export function checkSupport2YearsPrice(params) {
  return request({
    url: '/dynamic/info/deepoperate/checkSupportOneYearPrice',
    method: 'get',
    params,
  });
}

// 获取是否展示产品默认值
export function queryCalendarShowProduct(params) {
  return request({
    url: '/dynamic/info/deepoperate/calendarShowProduct',
    method: 'get',
    params,
  });
}
